import { Question } from "@/models/quiz.model";
import { QuizRest } from "@/services/rest/quiz.rest";
import { BehaviorSubject, map } from "rxjs";

export class QuizServiceTeacher {
  constructor(private _quiz = new QuizRest()) {}

  private question$ = new BehaviorSubject(new Question());
  question = this.question$.asObservable();

  getQuestionById(quizId: string, questionId: string): void {
    this._quiz
      .getQuestionById(quizId, questionId)
      .pipe(
        map((e) => {
          e.materialReferences?.forEach((ref) => {
            const totalMs = ref.referenceTime * 1000;
            const result = new Date(totalMs).toISOString().slice(11, 19);
            ref.referenceTime = result;
          });

          e.items?.forEach((item) => {
            const correct = e.correctItem.id === item.id ? true : false;
            item.correct = correct;
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.question$.next(response);
        },
      });
  }
}
